/**
 * Triggers a browser download via a hidden anchor element
 * @param {string} url - The URL to download
 * @param {string} filename - The desired filename for the downloaded file
 */
export function triggerDownload(url: string, filename: string): void {
  const virtualDownloadLink = document.createElement('a');
  virtualDownloadLink.style.display = 'none';
  virtualDownloadLink.href = url;
  virtualDownloadLink.download = filename;
  document.body.appendChild(virtualDownloadLink);
  virtualDownloadLink.click();
  virtualDownloadLink.remove();
}

/**
 * Downloads a file from a URL with a custom filename
 * @param {string} url - The URL of the file to download
 * @param {string} filename - The desired filename for the downloaded file
 * @param {boolean} fallbackToDirectDownload - Whether to fall back to direct download if blob download fails
 */
export function downloadFile(url: string, filename: string, fallbackToDirectDownload: boolean = true): Promise<void> {
  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      triggerDownload(blobUrl, filename);
      URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error downloading file as blob:', error);

      if (fallbackToDirectDownload) {
        triggerDownload(url, filename);
      } else {
        throw error;
      }
    });
}
